const toNumber = (value, fallback = 0) => {
    const n = Number(value);
    return Number.isNaN(n) ? fallback : n;
};
export const normalizeProductsList = (apiResponse, language = "el", page = 1, limit = 12) => {
    const d = apiResponse?.data;
    const itemsRaw = Array.isArray(d?.items) ? d.items : [];
    //const count = toNumber(d?.count, 0);

    const allItems = itemsRaw.map((item) => ({
        id: String(item.id),
        name: language === "en"
            ? (item.nameEN ?? item.nameEL ?? "")
            : (item.nameEL ?? item.nameEN ?? ""),
        nameEL: item.nameEL ?? "",
        nameEN: item.nameEN ?? "",
        brand: language === "en"
            ? (item.BrandEN ?? item.BrandEL ?? "")
            : (item.BrandEL ?? item.BrandEN ?? ""),
        brandEL: item.BrandEL ?? "",
        brandEN: item.BrandEN ?? "",
        category: language === "en"
            ? (item.CategoryEN ?? item.CategoryEL ?? "")
            : (item.CategoryEL ?? item.CategoryEN ?? ""),
        categoryEL: item.CategoryEL ?? "",
        categoryEN: item.CategoryEN ?? "",
        brandId: item.BrandId ? String(item.BrandId) : "",
        categoryId: item.CategoryId ? String(item.CategoryId) : "",
        colorId: item.Color ? String(item.Color) : "",
        image: item.image ?? "",
        price: toNumber(item.price, 0),
        priceOld: toNumber(item.priceOld, 0),
        specialOffer: item.specialOffer,
    }));
    const count = allItems.length;
    const safePage = Math.max(1, Number(page) || 1);
    const safeLimit = Math.max(1, Number(limit) || 12);
    const totalPages = Math.max(1, Math.ceil(count / safeLimit));

    const clampedPage = Math.min(safePage, totalPages);
    const startIndex = (clampedPage - 1) * safeLimit;
    const endIndex = startIndex + safeLimit;

    const items = allItems.slice(startIndex, endIndex);

    return {
        items,
        allItems,
        count,
        page: clampedPage,
        limit: safeLimit,
        totalPages,
    };
};